(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/coupon-static-row.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/coupon-static-row.js');
"use strict";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  useMemo,
  useEffect,
  useState,
  useCallback
} = React;
const {
  useLocation
} = ReactRouterDOM;
const {
  useSelector
} = ReactRedux;
const {
  useBetEvent,
  useBranding,
  useGetSelectedEventNumber,
  useIsTipsinfoEnabled
} = svs.components.tipsen.hooks;
const {
  baseUrl
} = svs.core.data;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  DescriptionSize
} = svs.components.lbUi.participants.constants;
const {
  TipsinfoTypes
} = svs.components.tipsen.engine.constants;
const {
  DistributionDisplay,
  ButtonBet,
  TeamNames,
  Checkmark,
  EventNumber,
  EventComment,
  Init
} = svs.components.tipsen.couponStatic;
const {
  TipsenLink
} = svs.components.tipsen.tipsen_link;
const {
  TipsenModuleGameUrl,
  buttonChoices,
  getOutcomeLabelsForEventType
} = svs.components.sport.tipsenShared;
const {
  STATISTIC_SIDEBAR_QUERY
} = svs.components.tipsen.constants;
const {
  useDrawSearchParams
} = svs.components.tipsen.drawProvider.hooks;
const {
  Tipsinfo
} = svs.components.tipsen.tipsinfo;
const {
  RenderContext
} = svs.components.sport.tipsenShared.constants;
const {
  selectResultOutcomeInfoChoises
} = svs.components.tipsen.selectors;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_MD
} = svs.components.lbUtils.useMediaQuery;
const {
  getIsDistributionDisplay,
  getProductDistribution,
  getShouldShowCheckmark,
  getShouldShowInit,
  getShouldShowCorrectResult,
  getShouldShowTeamNames
} = svs.components.tipsen.couponStatic.utils;
const {
  CorrectResult
} = svs.components.tipsen.couponStatic;
const createCouponRowHref = () => {
  const href = location.pathname.replace(baseUrl, '');
  return href;
};
const getEventClassName = _ref => {
  let {
    isGoalCount,
    mSign
  } = _ref;
  const mainClassName = 'pg_coupon_static__event';
  let className = mainClassName;
  if (isGoalCount) {
    className = "".concat(className, " ").concat(mainClassName, "--goal_count");
  }
  if (mSign) {
    className = "".concat(className, " ").concat(mainClassName, "--m_sign");
  }
  return className;
};
const defaultClassList = ['pg_coupon_static__event_container'];
const animationFadeOut = 'fadeOutAnimation';
const CouponStaticRow = _ref2 => {
  var _useSelector, _productDistribution$, _productDistribution$2, _productDistribution$3;
  let {
    alwaysIncludeParams,
    drawCompetitionId,
    drawEvent,
    drawResult,
    drawState,
    playerBet = [],
    sportType,
    drawNumber,
    productId,
    nameSize = DescriptionSize.Medium,
    isCompressed = false,
    distributionChoice = [],
    selectedCouponChoice = buttonChoices.GAMES,
    systemType,
    bestBetRowResult,
    mSign,
    uSign,
    hasChangedResult
  } = _ref2;
  const drawId = ''.concat(productId, '_').concat(drawNumber);
  const betButtons = getOutcomeLabelsForEventType(drawEvent.eventTypeId, sportType);
  const isGoalCount = drawEvent.eventTypeId === EventTypeId.GOAL_COUNT;
  const isHead2Head = drawEvent.eventTypeId === EventTypeId.HEAD_TO_HEAD;
  const selectedEventNumber = useGetSelectedEventNumber();
  const isSelected = drawEvent.eventNumber === selectedEventNumber;
  const branding = useBranding(drawId, drawCompetitionId);
  const [productBanding] = branding;
  const resultOutcomeInfoChoices = (_useSelector = useSelector(selectResultOutcomeInfoChoises)) === null || _useSelector === void 0 ? void 0 : _useSelector.displayResult;
  const toParams = useDrawSearchParams(productId, drawNumber, drawEvent.eventNumber, alwaysIncludeParams);
  const searchParams = new URLSearchParams(toParams);
  const showCouponAndDetailView = useMediaQuery(STATISTIC_SIDEBAR_QUERY);
  if (!showCouponAndDetailView) {
    searchParams.set('openStatistic', '');
  }
  const location = useLocation();
  const isResult = location.pathname.includes("/".concat(TipsenModuleGameUrl.RESULT));
  const {
    eventStatistics
  } = useBetEvent({
    productId,
    drawNumber,
    eventNumber: drawEvent.eventNumber
  });
  const productDistribution = getProductDistribution({
    eventStatistics,
    productId,
    drawNumber
  });
  const displayProductDistributionValue = (productDistribution === null || productDistribution === void 0 ? void 0 : (_productDistribution$ = productDistribution.current) === null || _productDistribution$ === void 0 ? void 0 : _productDistribution$.value[0]) && (productDistribution === null || productDistribution === void 0 ? void 0 : (_productDistribution$2 = productDistribution.current) === null || _productDistribution$2 === void 0 ? void 0 : _productDistribution$2.value[1]) && (productDistribution === null || productDistribution === void 0 ? void 0 : (_productDistribution$3 = productDistribution.current) === null || _productDistribution$3 === void 0 ? void 0 : _productDistribution$3.value[2]);
  const betButtonsToShow = useMemo(() => {
    if (resultOutcomeInfoChoices === TipsinfoTypes.SvenskaFolket && displayProductDistributionValue && !isCompressed) {
      return productDistribution.current.value.map((result, index) => _objectSpread(_objectSpread({}, result), {}, {
        resultIndex: index,
        resultText: {
          text: "".concat(result, "%")
        }
      }));
    }
    const buttonsToReturn = betButtons.map(btn => _objectSpread(_objectSpread({}, btn), {}, {
      resultIndex: betButtons.indexOf(btn),
      resultText: btn
    }));
    if (isCompressed) {
      return buttonsToReturn.filter(button => button.resultIndex === (drawResult === null || drawResult === void 0 ? void 0 : drawResult.outcome));
    }
    return buttonsToReturn;
  }, [resultOutcomeInfoChoices, displayProductDistributionValue, isCompressed, betButtons, productDistribution, drawResult === null || drawResult === void 0 ? void 0 : drawResult.outcome]);
  const resultOutcomeInfoChoicesState = useSelector(selectResultOutcomeInfoChoises);
  const outcomeInfoChoicesStateDisplay = resultOutcomeInfoChoicesState.displayResult;
  const {
    resultContext: {
      isAnyTipsinfoEnabled
    }
  } = useIsTipsinfoEnabled();
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const [classList, setClassList] = useState(defaultClassList);
  useEffect(() => {
    if (hasChangedResult) {
      setClassList([...defaultClassList, 'pg_coupon_static__event_container--changed_result']);
    }
  }, [hasChangedResult]);
  const handleAnimationEnd = useCallback(event => {
    if (event.animationName === animationFadeOut) {
      setClassList(defaultClassList);
    }
  }, []);
  const getButtonBetClassNames = () => {
    const classNames = ['pg_coupon_static__bet_buttons'];
    if (branding && branding.length > 0) {
      classNames.push("pg_coupon_static__bet_buttons--".concat(branding.join(' ')));
    }
    return classNames.join(' ');
  };
  return React.createElement("div", _extends({
    className: classList.join(' ')
  }, isSelected ? {
    'aria-selected': true
  } : {}, {
    onAnimationEnd: handleAnimationEnd
  }), React.createElement(TipsenLink, {
    className: getEventClassName({
      isCompressed,
      isGoalCount,
      mSign
    }),
    disabled: isHead2Head 
    ,
    to: {
      pathname: createCouponRowHref(),
      search: "?".concat(searchParams)
    }
  }, React.createElement("div", {
    className: "pg_coupon_static__event_number"
  }, React.createElement(EventNumber, {
    bestBetRowResult: bestBetRowResult,
    branding: productBanding,
    drawResult: drawResult,
    eventNumber: drawEvent.eventNumber,
    eventTypeId: drawEvent.eventTypeId,
    isCompressed: isCompressed,
    userRow: playerBet
  })), getShouldShowTeamNames({
    selectedCouponChoice,
    isCompressed
  }) && React.createElement("div", {
    className: "pg_coupon_static__event_desc f-medium ".concat(isGoalCount ? 'fc-fulltraff-400' : '')
  }, React.createElement(TeamNames, {
    drawEventNumber: drawEvent.eventNumber,
    drawNumber: drawNumber,
    isHead2Head: isHead2Head,
    nameSize: nameSize,
    productId: productId
  })), getIsDistributionDisplay(selectedCouponChoice) && isCompressed && React.createElement(DistributionDisplay, {
    distributionChoice: distributionChoice,
    drawNumber: drawNumber,
    eventNumber: drawEvent.eventNumber,
    productId: productId,
    selectedCouponChoice: selectedCouponChoice
  }), getShouldShowCheckmark({
    systemType,
    isResult,
    isGoalCount,
    isCompressed
  }) && React.createElement(Checkmark, {
    drawResult: drawResult,
    isGoalCount: isGoalCount,
    isResult: isResult,
    systemType: systemType,
    userRow: playerBet
  }), getShouldShowInit({
    isGoalCount,
    isCompressed,
    selectedCouponChoice,
    isSmall
  }) && React.createElement(Init, {
    drawEvent: drawEvent,
    drawNumber: drawNumber,
    drawState: drawState,
    eventNumber: drawEvent.eventNumber,
    isCompressed: isCompressed,
    isResultPage: isResult,
    productId: productId,
    selectedCouponChoice: selectedCouponChoice
  }), !isCompressed && mSign && React.createElement("span", {
    className: "pg_coupon_static__m_sign"
  }, "M"), !isCompressed && React.createElement("div", {
    className: getButtonBetClassNames()
  }, betButtonsToShow.map((result, index) => React.createElement(ButtonBet, {
    branding: productBanding,
    isCorrect: result.resultIndex === (drawResult === null || drawResult === void 0 ? void 0 : drawResult.outcome),
    key: result.text,
    outcome: playerBet[index],
    result: result.resultText,
    systemType: systemType,
    uSign: uSign === index
  }))), getShouldShowCorrectResult({
    isCompressed,
    isGoalCount,
    isSmall,
    selectedCouponChoice
  }) && React.createElement(CorrectResult, {
    betButtonsToShow: betButtonsToShow
  }), !isCompressed && React.createElement(EventComment, {
    drawEvent: drawEvent,
    drawNumber: drawNumber,
    drawResult: drawResult,
    drawState: drawState,
    productId: productId
  }), !isCompressed && isAnyTipsinfoEnabled && React.createElement("div", {
    className: "pg_coupon_static__tipsinfo"
  }, React.createElement(Tipsinfo, {
    drawId: drawId,
    drawNumber: drawNumber,
    eventNumber: drawEvent.eventNumber,
    outcomeInfoChoisesStateDisplay: outcomeInfoChoicesStateDisplay,
    outcomeLabels: betButtons,
    productId: productId,
    renderContext: RenderContext.ResultOrMybets
  }))));
};
setGlobal('svs.components.tipsen.couponStatic.CouponStaticRow', CouponStaticRow);

 })(window);